export const MyClientsPages = {
  MAIN: "/",
  DASHBOARD: "dashboard",
  ASSETS: "assets",
  ADD_CLIENT: "add-client",
  EDIT_CLIENT: "edit-client",
};
